import { useState } from 'react';
import { useResetRecoilState, useSetRecoilState } from 'recoil';

import {
  comboxWebConfigAtom,
  dmsCommandsAtom,
} from '@asa/asasqt-microfrontend-components/dist/common/guards/dmsGuard/core/recoil';
import {
  isAuthenticatedAtom,
  tokenAtom,
  userDetailsAtom,
  userServicesAtom,
  userSettingsApiDataAtom,
} from '@asa/asasqt-microfrontend-components/dist/common/state/shared/auth';
import { quotationInformationAtom } from '@asa/asasqt-microfrontend-components/dist/common/state/shared/quotation';
import {
  accountSettingsAtom,
  selectedCurrencyAtom,
} from '@asa/asasqt-microfrontend-components/dist/common/state/shared/settings';
import { useLogoutBase } from '@asa/asasqt-microfrontend-components/dist/hooks/auth/useLogout';

import { hasLicenseAtom } from '@/core/auth/core/auth.recoil';
import {
  appointmentRequestsToggleAtom,
  serviceAppSettingsAtom,
} from '@/core/common/containers/serviceApp/core';
import { URLRoutes } from '@/core/common/helpers/urlRoutes';
import {
  appointmentDateFilterDataAtom,
  dashboardSearchValueAtom,
} from '@/core/dashboard/core/recoil.atom';

import { useAxiosIntercept } from '../axios/axios.context';
import {
  hasLegalDocsToAcceptAtom,
  legalDocumentsAcceptanceAtom,
} from '../recoil';

const useLogout = () => {
  const setIsAuthenticated = useSetRecoilState(isAuthenticatedAtom);
  const resetAuth = useResetRecoilState(isAuthenticatedAtom);
  const resetUserServices = useResetRecoilState(userServicesAtom);
  const resetTokenAtom = useResetRecoilState(tokenAtom);
  const resetLicense = useResetRecoilState(hasLicenseAtom);
  const setUserDetails = useResetRecoilState(userDetailsAtom);
  const resetAccountSettings = useResetRecoilState(accountSettingsAtom);
  const resetUserSettings = useResetRecoilState(userSettingsApiDataAtom);
  const resetAppointmentFilter = useResetRecoilState(
    appointmentDateFilterDataAtom
  );
  const resetHasLegalDocsToAccept = useResetRecoilState(
    hasLegalDocsToAcceptAtom
  );
  const resetSelectedCurrency = useResetRecoilState(selectedCurrencyAtom);
  const resetLegalDocumentsAcceptance = useResetRecoilState(
    legalDocumentsAcceptanceAtom
  );
  const resetQuotationInformation = useResetRecoilState(
    quotationInformationAtom
  );
  const resetDashboardSearchValue = useResetRecoilState(
    dashboardSearchValueAtom
  );
  const resetServiceAppSettings = useResetRecoilState(serviceAppSettingsAtom);
  const resetAppointmentRequestToggle = useResetRecoilState(
    appointmentRequestsToggleAtom
  );
  const resetDmsCommands = useResetRecoilState(dmsCommandsAtom);
  const resetComboxWebConfig = useResetRecoilState(comboxWebConfigAtom);

  const [hasLoggedOut, setHasLoggedOut] = useState(false);

  const axiosIntercept = useAxiosIntercept();

  const frontendLogout = () => {
    resetUserServices();
    resetAuth();
    setIsAuthenticated(false);
    resetTokenAtom();
    resetLicense();
    setUserDetails();
    resetAccountSettings();
    resetUserSettings();
    resetLegalDocumentsAcceptance();
    resetHasLegalDocsToAccept();
    resetSelectedCurrency();
    resetQuotationInformation();
    resetDashboardSearchValue();
    resetAppointmentFilter();
    resetAppointmentRequestToggle();
    resetServiceAppSettings();
    resetDmsCommands();
    resetComboxWebConfig();
    setHasLoggedOut(true);
  };

  const logout = useLogoutBase({
    axiosIntercept,
    redirectPath: `${URLRoutes.auth}`,
    frontendLogout,
  });

  return {
    ...logout,
    hasLoggedOut,
  };
};

export default useLogout;
